export default __webpack_public_path__ + "static/media/uranus_texture.43f8336c.jpg";